import { render, staticRenderFns } from "./VendorKanban.vue?vue&type=template&id=4fe1f4b8&"
import script from "./VendorKanban.vue?vue&type=script&lang=js&"
export * from "./VendorKanban.vue?vue&type=script&lang=js&"
import style0 from "./VendorKanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports